import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface TachographCardDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const TachographCardDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: TachographCardDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={t("delete")}
      description={`${t("are_you_sure_you_want_delete")}?`}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default TachographCardDelete;
